import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { useEventEmailFolders } from '../hooks/useEventEmailFolders';
import { EmailBoxContext } from './EmailBoxContext';
import { EventParticipationsContext } from './EventParticipationContextV2';

// eslint-disable-next-line import/prefer-default-export
export const EventEmailBoxContextProvider = () => {
  const { participations, unreadMessagesProps } = useContext(EventParticipationsContext);
  const value = useEventEmailFolders(
    participations.map((p) => p.contactId),
    unreadMessagesProps,
  );

  return (
    <EmailBoxContext.Provider value={value}>
      <Outlet />
    </EmailBoxContext.Provider>
  );
};
